import { render, staticRenderFns } from "./PushNotification.vue?vue&type=template&id=66cdff82&scoped=true"
import script from "./PushNotification.vue?vue&type=script&lang=js"
export * from "./PushNotification.vue?vue&type=script&lang=js"
import style0 from "./PushNotification.vue?vue&type=style&index=0&id=66cdff82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cdff82",
  null
  
)

export default component.exports